// src/services/clientService.js
import axios from "axios";

const API_BASE_URL = "https://lead-tracker-backend-gyoa.onrender.com/api"; // Change to your backend URL

export const getClientData = async (clientId) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/leads/${clientId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching client data:", error);
    throw error;
  }
};
